import { get } from 'lodash';

const styles = ({ padding, margin, color }) => ({
  loginForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: get(padding, 'p12'),
  },
  fieldContainer: {
    margin: "0 !important",
    '& .MuiFormLabel-root': {
      display: 'none',
    },
  },
  textField: {
    padding: '0px !important',
  },
  eulaCheckboxLabel: {
    display: 'flex',
    gap: get(padding, 'p4'),
  },
  actionButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: get(padding, 'p12'),
    marginTop: get(margin, 'm12'),
  },
  buttonStyles: {
    height: "auto",
    padding: "4px 8px 4px 12px",
    '&:focus': {
      outlineOffset: "1px",
      outline: `1px solid ${get(color, 'primaryButtonBackground')}`,
    },
  },
  buttonContent: {
    lineHeight: '14px',
    fontWeight: 600,
    minHeight: '14px',
    flexGrow: 1,
    padding: "9px 8px",
  },
  forgotPasswordButton: {
    height: "auto",
    padding: "4px 8px 4px 12px",
    '&:focus': {
      outline: `1px solid ${get(color, 'primaryButtonBackground')}`,
    },
  },
  multipleSessionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: get(padding, 'p4'),
    margin: 0,
  },
});

export default styles;